import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../utils/API";

import LakeBedWorld from "../features/world/LakeBedWorld";

function LakeBedGame() {
  const { id } = useParams();
  const [avatar, setAvatar] = useState(null);
  const [avatarName, setAvatarName] = useState(null);

  useEffect(() => {
    API.getUser(id).then((response) => response.json()).then((user) => {
      const { sprite, name } = user.sprite[0];
      setAvatar(sprite);
      setAvatarName(name);
    });
  }, [id]);

  return (
    <div>
      <LakeBedWorld avatar={avatar} avatarName={avatarName} />

    </div>
  );
}

export default LakeBedGame;
